import React from 'react';
import PropTypes from 'prop-types';
import ReactHelmet from 'react-helmet';

import favicon from 'assets/images/favicon.ico';

const Helmet = ({ title }) => (
  <ReactHelmet>
    <title>{ title }</title>
    <link rel="icon" type="image/png" href={favicon} sizes="32x32" />
  </ReactHelmet>
);

Helmet.propTypes = {
  title: PropTypes.string
};

Helmet.defaultProps = {
  title: 'An app for your tutoring business in minutes · Tewtor'
};

export default Helmet;



// WEBPACK FOOTER //
// ./src/components/Helmet/index.js